import { useGetWireDisbursementQuery } from 'API/order/escrow/WireDisbursementAPI';
import { useMemo } from 'react';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { IDisbursementFormData } from 'types/order/escrow/IDisbursementFormData';
import { useGetCheckDisbursementQuery } from 'API/order/escrow/CheckDisbursementAPI';
import { useGetACHDisbursementQuery } from 'API/order/escrow/AchDisbursementAPI';
import { useGetInternalTransferDisbursementQuery } from 'API/order/escrow/InternalTransferDisbursementAPI';

export interface IUseGetDisbursementProps {
  disbursement: IDisbursementFormData;
}

export const useGetDisbursement = ({ disbursement }: IUseGetDisbursementProps) => {
  const { id, type, isNew } = disbursement;
  /** Since this is a hook, we have to keep in mind all hooks need to run. So this will have some skips, and be slightly odd
   * to keep things from breaking hook wise.
   */
  const wire = useGetWireDisbursementQuery({ wireId: id ?? '' }, { skip: type !== eDisbursementType.Wire || isNew });
  const check = useGetCheckDisbursementQuery(
    { checkId: id ?? '' },
    { skip: type !== eDisbursementType.Check || isNew }
  );
  const ach = useGetACHDisbursementQuery({ achId: id ?? '' }, { skip: type !== eDisbursementType.ACH || isNew });
  const internalTransfer = useGetInternalTransferDisbursementQuery(
    { internalTransferId: id ?? '' },
    { skip: type !== eDisbursementType.InternalTransfer || isNew }
  );
  const allTypes = useMemo(
    () => ({
      [eDisbursementType.Wire]: wire,
      [eDisbursementType.Check]: check,
      [eDisbursementType.ACH]: ach,
      [eDisbursementType.InternalTransfer]: internalTransfer,
    }),
    [wire, check, ach, internalTransfer]
  );

  return useMemo(() => {
    const typeToUse = allTypes[type];
    return {
      ...typeToUse,
      data: typeToUse.data ?? disbursement,
    };
  }, [allTypes, type, disbursement]);
};
